import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, Image } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'src/store';
import { actions, settingDropdownSelector } from 'src/store/ui/menu';
import LocalStorage from 'src/utils/LocalStorage';
import { PATH } from 'src/constants/app';
import { logoutApp } from 'src/thunks/auth';
import default_img from 'src/assets/default_profile.jpeg';
import { isAdminSelector } from 'src/utils/helper';

const UserDropdown: React.FC = () => {
  const authInfo = useAppSelector((state) => state.ui.app.me);
  const location = useLocation();
  const { menu, isActive } = useAppSelector((state) =>
    settingDropdownSelector(state, location.pathname),
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdmin = useAppSelector(isAdminSelector);

  React.useEffect(() => {
    dispatch(actions.setAdminState(isAdmin as boolean));
  }, [isAdmin, dispatch]);

  return (
    <Dropdown
      direction="left"
      icon={null}
      trigger={
        <Image
          width={38}
          height={38}
          circular
          className="object-fit-cover"
          src={authInfo?.profile_picture || default_img}
          id="user_dropdown"
        />
      }
      options={[
        ...menu,
        {
          key: 'logout',
          text: <a className="d-block">Logout</a>,
          value: 'logout',
        },
      ]}
      value={isActive && String(location.pathname.split('/')[2])}
      onChange={async (event, data) => {
        if (data.value === 'logout') {
          await dispatch(logoutApp());
          dispatch({ type: 'logout' });
          LocalStorage.removeInfo();
          navigate(`${PATH.LOGIN}`);
        }
      }}
    />
  );
};

export default UserDropdown;
